import { Text, View } from 'react-native'
import { Card } from './CardComponent'
import theme from '../../../theme'
import * as Progress from 'react-native-progress'
import {
    LineChartCardChat,
    ComparisonBarChartChat,
    SimpleDataBarChartCardChat,
    VerticalStackedBarsChat,
} from './DotiChatCharts'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { useState } from 'react'
import { generalFontSize, generalLineHeigth } from './constants/doti.constants'

const itemsSpacing = 0

export const DotiItemChat = ({ item, listView }) => {
    switch (item.type) {
        case 'TasksCard':
            return <TasksCardChat data={item.values ?? []} />
        case 'CircleStatCard':
            return (
                <CircleStatCardChat
                    title={item.title}
                    value={item.value}
                    subtitle={item.description}
                    change={item.change}
                    styles={{
                        shadowOpacity: 0,
                        shadowRadius: 0,
                        elevation: 0,
                    }}
                />
            )
        case 'CoursesCard':
            return (
                <CoursesCardChat
                    completed={item.completed}
                    total={item.value}
                    styles={{
                        shadowOpacity: 0,
                        shadowRadius: 0,
                        elevation: 0,
                    }}
                />
            )
        case 'LineChartCard':
            return (
                <LineChartCardChat
                    title={item.title}
                    value={item.value}
                    data={item.values}
                />
            )
        case 'DeadlineCard':
            return (
                <DeadlineCardChat
                    title={item.title}
                    value={item.value}
                    description={item.description}
                    change={item.change}
                    descriptionColor={item.progressColor}
                    styles={{
                        shadowOpacity: 0,
                        shadowRadius: 0,
                        elevation: 0,
                    }}
                />
            )
        case 'OpportunityCard':
            return <OpportunityCardChat title={item.title} data={item.values} />
        case 'SimpleDataBarChartCard':
            return (
                <SimpleDataBarChartCardChat
                    title={item.title}
                    data={item.values}
                    styles={{
                        marginHorizontal: itemsSpacing,
                        shadowOpacity: 0,
                        shadowRadius: 0,
                        elevation: 0,
                    }}
                />
            )
        case 'ComparisonBarChart':
            return (
                <ComparisonBarChartChat
                    styles={{
                        margin: itemsSpacing,
                        shadowOpacity: 0,
                        shadowRadius: 0,
                        elevation: 0,
                    }}
                    title={item.title}
                    data={item.values}
                />
            )
        case 'VerticalStackedBars':
            return (
                <VerticalStackedBarsChat
                    styles={{
                        marginHorizontal: itemsSpacing,
                        marginBottom: itemsSpacing * 2,
                        shadowOpacity: 0,
                        shadowRadius: 0,
                        elevation: 0,
                        overflow: 'hidden',
                    }}
                    title={item.title}
                    data={item.values}
                />
            )
        case 'GroupCards':
            // let newCards = [...item.cards.slice(0, 4)]
            return (
                <MultipleProgressCardChat
                    cards={item.cards ?? []}
                    listView={listView}
                />
            )
        case 'ProgressDetailCard':
            return (
                <ProgressDetailCardChat
                    title={item.title}
                    value={item.value}
                    subtitle={item.description}
                    change={item.change}
                    details={item.details || []}
                />
            )
        default:
            return <></>
    }
}
export const TasksCardChat = ({ data }) => {
    return (
        <Card
            style={{
                shadowOpacity: 0,
                shadowRadius: 0,
                elevation: 0,
            }}
        >
            {data.map((item, index) => (
                <View
                    key={index}
                    style={{
                        flexDirection: 'row',
                        marginBottom: index != data.length - 1 ? 8 : 0,
                        width: '100%',
                    }}
                >
                    <Text
                        style={{
                            fontWeight: '700',
                            color: 'black',
                            marginRight: 6,
                            fontSize: generalFontSize,
                            lineHeight: generalLineHeigth,
                        }}
                    >
                        {index + 1}.
                    </Text>

                    <ColoredPercentageText text={item.value} />
                </View>
            ))}
        </Card>
    )
}

export const ColoredPercentageText = ({ text }) => {
    // Busco un número con o sin signo seguido de %
    const match = text.match(/([+-]?\d+(\.\d+)?)%/)

    // Si no hay ningún porcentaje, devuelvo el texto tal cual
    if (!match)
        return (
            <Text
                style={{
                    color: theme.colors.textPrimary,
                    flex: 1,
                    fontWeight: '400',
                }}
            >
                {text}
            </Text>
        )

    const [fullMatch, num] = match // ejemplo: "12%"
    const number = parseFloat(num) // ejemplo: 12
    const color =
        number > 0 ? 'green' : number < 0 ? 'red' : theme.colors.textPrimary

    const before = text.slice(0, match.index)
    const after = text.slice(match.index + fullMatch.length)

    return (
        <Text
            style={{
                flex: 1,
                fontWeight: '400',
                marginEnd: 0,
                color: theme.colors.textPrimary,
                fontSize: generalFontSize,
                lineHeight: generalLineHeigth,
            }}
        >
            {before}
            <Text
                style={{
                    fontWeight: '600',
                    color,
                }}
            >
                {fullMatch}
            </Text>
            {after}
        </Text>
    )
}

export const DeadlineCardChat = ({
    title,
    value,
    description,
    change = null,
    descriptionColor,
    styles,
}) => {
    const descColor =
        descriptionColor && descriptionColor != ''
            ? descriptionColor
            : theme.colors.textPrimary
    return (
        <Card style={styles}>
            <Text
                style={{
                    fontSize: generalFontSize,
                    lineHeight: generalLineHeigth,
                    fontWeight: '600',
                    marginBottom: 10,
                    color: theme.colors.textPrimary,
                    textAlign: 'center',
                }}
            >
                {title}
            </Text>

            <Text
                style={{
                    fontSize: 42,
                    fontWeight: '700',
                    color: '#5758FF',
                    textAlign: 'center',
                }}
            >
                {value}
            </Text>

            <Text
                style={{
                    marginTop: 0,
                    fontSize: generalFontSize,
                    lineHeight: generalLineHeigth,
                    textAlign: 'center',
                }}
            >
                {typeof change === 'number' && (
                    <Text
                        style={{
                            color: change >= 0 ? 'green' : 'red',
                            fontWeight: '600',
                        }}
                    >
                        {change > 0 ? `+${change}% ` : `${change}% `}
                    </Text>
                )}

                <Text style={{ color: descColor, fontWeight: '400' }}>
                    {description}
                </Text>
            </Text>
        </Card>
    )
}

export const CircleStatCardChat = ({
    style,
    title,
    value = 0,
    subtitle,
    change = null,
    showCard = true,
    progressColor = null,
    unfilledColor = '#D0D2E7',
    verySmall = false,
}) => {
    let Parent = Card
    if (showCard === false) Parent = View
    const progressText = value ? `${value.toFixed(0)}%` : '0%'
    const percentage = value / 100
    let newColor =
        progressColor && progressColor != ''
            ? progressColor
            : theme.colors.colorPrimary
    const size = !verySmall ? 88 : 80
    return (
        <Parent style={style}>
            <View style={{ alignItems: 'center', marginBottom: 10 }}>
                {/* Círculo (simplificado) */}

                <Progress.Circle
                    size={size}
                    progress={percentage}
                    showsText={false}
                    thickness={6}
                    color={newColor}
                    unfilledColor={unfilledColor}
                    borderWidth={0}
                    strokeCap='round'
                />
                <Text
                    style={{
                        position: 'absolute',
                        textAlign: 'center',
                        lineHeight: size,
                        height: size,
                        width: size,
                        fontSize: !verySmall ? 20 : 18,
                        fontWeight: '700',
                        color: theme.colors.textPrimary,
                    }}
                    adjustsFontSizeToFit
                    minimumFontScale={0.7}
                >
                    {progressText}
                </Text>
            </View>

            <Text
                style={{
                    textAlign: 'center',
                    fontSize: generalFontSize,
                    lineHeight: generalLineHeigth,
                    fontWeight: '600',
                    color: theme.colors.textPrimary,
                    marginBottom: change ? 6 : 0,
                }}
            >
                {title}
            </Text>

            {change ? (
                <Text
                    style={{
                        textAlign: 'center',
                        color: change > 0 ? 'green' : 'red',
                        fontWeight: '600',
                        fontSize: generalFontSize,
                    }}
                >
                    {change > 0 ? `+${change}%` : `${change}%`}
                    <Text
                        style={{
                            color: theme.colors.textPrimary,
                            fontWeight: '400',
                        }}
                    >
                        {' ' + subtitle}
                    </Text>
                </Text>
            ) : null}

            {!change && subtitle && (
                <Text style={{ textAlign: 'center', color: '#7B7B7B' }}>
                    {subtitle}
                </Text>
            )}
        </Parent>
    )
}

export const CoursesCardChat = ({
    style,
    completed = 0,
    total = 0,
    showCard = true,
    verySmall = false,
    progressColor = null,
}) => {
    let Parent = Card
    if (showCard === false) Parent = View
    let value = 0
    let percentage = 0
    if (total > 0) {
        value = (completed * 100) / total
    }
    percentage = value / 100
    const progressText = completed + ' de ' + total
    const newColor = progressColor && progressColor != '' ? progressColor : '#009E4D'
    return (
        <Parent style={style}>
            <View style={{ alignItems: 'center' }}>
                <Progress.Circle
                    size={!verySmall ? 88 : 80}
                    progress={percentage}
                    showsText={true}
                    formatText={(progress) => progressText}
                    textStyle={{
                        fontSize: !verySmall ? 20 : 18,
                        fontWeight: '700',
                        color: theme.colors.textPrimary,
                    }}
                    thickness={6}
                    color={newColor}
                    unfilledColor={'#D2EBD7'}
                    borderWidth={0}
                    strokeCap='round'
                />

                <Text
                    style={{
                        textAlign: 'center',
                        marginTop: 10,
                        fontSize: generalFontSize,
                        lineHeight: generalLineHeigth,
                        fontWeight: '600',
                        color: theme.colors.textPrimary,
                        flex: 1,
                    }}
                >
                    {'Cursos completados \neste mes'}
                </Text>
            </View>
        </Parent>
    )
}

export const OpportunityCardChat = ({ title, data }) => {
    return (
        <Card
            style={{
                shadowOpacity: 0,
                shadowRadius: 0,
                elevation: 0,
            }}
        >
            <Text
                style={{
                    fontSize: generalFontSize,
                    lineHeight: generalLineHeigth,
                    fontWeight: '600',
                    color: theme.colors.textPrimary,
                    marginBottom: 10,
                }}
            >
                {title}
            </Text>
            {data.map((item, index) => (
                <View key={index} style={{ marginBottom: 24, flex: 1 }}>
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            marginBottom: 6,
                        }}
                    >
                        <Text
                            style={{
                                fontSize: generalFontSize,
                                lineHeight: generalLineHeigth,
                                color: '#1A1A1A',
                                maxWidth: '60%',
                            }}
                            ellipsizeMode='tail'
                            numberOfLines={1}
                        >
                            {item.value}
                        </Text>

                        <View
                            style={{
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 0,
                            }}
                        >
                            {item.percent && item.percent < 40 && (
                                <MaterialCommunityIcons
                                    name='alert'
                                    size={18}
                                    color='#E54335'
                                />
                            )}
                            <Text
                                style={{
                                    fontSize: generalFontSize,
                                    lineHeight: generalLineHeigth,
                                    fontWeight: '600',
                                    color:
                                        item.percent < 40
                                            ? '#E54335'
                                            : theme.colors.colorPrimary,
                                }}
                            >
                                {item.percent}%
                            </Text>
                        </View>
                    </View>

                    {/* Barra de progreso */}
                    <View
                        style={{
                            height: 8,
                            backgroundColor: '#D8D6E5',
                            borderRadius: 8,
                            flex: 1,
                        }}
                    >
                        <View
                            style={[
                                {
                                    height: 8,
                                    backgroundColor:
                                        item.percent < 40
                                            ? '#E54335'
                                            : theme.colors.colorPrimary,
                                    borderRadius: 8,
                                },
                                { width: `${item.percent}%` },
                            ]}
                        />
                    </View>
                </View>
            ))}
        </Card>
    )
}

export const MultipleProgressCardChat = ({ cards, listView = false }) => {
    const [cardWidth, setCardWidth] = useState(0)
    const verySmall = listView && cardWidth < 370
    const containerMaxWidth = verySmall ? 100 : 120
    if (!cards || cards.length === 0) {
        return <></>
    }
    const GHOST_ID = 'ghost-item'

    const fillRowWithGhosts = (row, itemPerRow) => {
        const missing = itemPerRow - row.length
        if (missing <= 0) return row

        const ghosts = Array(missing)
            .fill(0)
            .map((_, i) => ({
                id: `${GHOST_ID}-${i}`,
                type: 'ghost',
            }))

        return [...row, ...ghosts]
    }
    const chunkArray = (array, size = 3) => {
        const rawRows = array.reduce((acc, _, i) => {
            if (i % size === 0) acc.push(array.slice(i, i + size))
            return acc
        }, [])

        // 👉 aplicar ghosts SOLO desde la segunda fila
        return rawRows.map((row, index) =>
            index === 0 ? row : fillRowWithGhosts(row, size),
        )
    }

    const itemPerRow = 3
    const rows = chunkArray(cards, itemPerRow)

    const renderItem = (item) => {
        if (item.type === 'ghost') {
            return <View style={{ opacity: 0 }} />
        }
        switch (item.type) {
            case 'CircleStatCard':
                return (
                    <CircleStatCardChat
                        title={item.title}
                        value={item.value}
                        showCard={false}
                        verySmall={verySmall}
                        progressColor={item.progressColor}
                    />
                )

            case 'CoursesCard':
                return (
                    <CoursesCardChat
                        completed={item.completed}
                        total={item.value}
                        showCard={false}
                        verySmall={verySmall}
                    />
                )

            default:
                return null
        }
    }
    const justifyContent = (fullRow) => {
        if (!fullRow) return 'space-evenly'
        if (cards.length === 1) return 'center'
        if (cards.length === 2) return 'space-evenly'
        return 'space-between'
    }
    console.log('jUSTIF', justifyContent())
    return (
        <Card
            style={{
                width: '100%',
                shadowOpacity: 0,
                shadowRadius: 0,
                elevation: 0,
            }}
        >
            {rows.map((row, rowIndex) => {
                const isFullRow = row.length === itemPerRow

                return (
                    <View
                        key={rowIndex}
                        style={{
                            flexDirection: 'row',
                            justifyContent: isFullRow
                                ? justifyContent(isFullRow)
                                : justifyContent(isFullRow),
                            marginBottom: 0,
                        }}
                    >
                        {row.map((item, index) => {
                            let isLastRow = rowIndex === rows.length - 1
                            return (
                                <View
                                    key={index}
                                    style={{
                                        width: 88,
                                        marginBottom: !isLastRow ? 10 : 0,
                                        // marginHorizontal: isFullRow ? 0 : 10,
                                    }}
                                >
                                    {renderItem(item)}
                                </View>
                            )
                        })}
                    </View>
                )
            })}
        </Card>
    )
}

export const ProgressDetailCardChat = ({
    title,
    value,
    subtitle,
    change,
    details = [],
}) => {
    return (
        <Card style={{ flex: 1, shadowOpacity: 0, shadowRadius: 0, elevation: 0 }}>
            <CircleStatCardChat
                showCard={false}
                title={title}
                value={value}
                subtitle={subtitle}
                change={change}
            />
            {details.length > 0 &&
                details.map((item, index) => (
                    <View key={index} style={{ marginVertical: 12, flex: 1 }}>
                        <View
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                marginBottom: 6,
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: generalFontSize,
                                    lineHeight: generalLineHeigth,
                                    color: '#1A1A1A',
                                    maxWidth: '60%',
                                    fontWeight: '700',
                                }}
                                ellipsizeMode='tail'
                                numberOfLines={1}
                            >
                                {item.label}
                            </Text>

                            <View
                                style={{
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 0,
                                }}
                            >
                                {item.value && item.value < 40 && (
                                    <MaterialCommunityIcons
                                        name='alert'
                                        size={18}
                                        color='#E54335'
                                    />
                                )}
                                <Text
                                    style={{
                                        fontSize: generalFontSize,
                                        lineHeight: generalLineHeigth,
                                        fontWeight: '600',
                                        color:
                                            item.value < 40
                                                ? '#E54335'
                                                : theme.colors.colorPrimary,
                                    }}
                                >
                                    {item.value}%
                                </Text>
                            </View>
                        </View>

                        {/* Barra de progreso */}
                        <View
                            style={{
                                height: 8,
                                backgroundColor: '#D8D6E5',
                                borderRadius: 8,
                                flex: 1,
                            }}
                        >
                            <View
                                style={[
                                    {
                                        height: 8,
                                        backgroundColor:
                                            item.value < 40
                                                ? '#E54335'
                                                : theme.colors.colorPrimary,
                                        borderRadius: 8,
                                    },
                                    { width: `${item.value}%` },
                                ]}
                            />
                        </View>
                        {item.description && (
                            <Text
                                style={{
                                    fontSize: generalFontSize,

                                    lineHeight: generalLineHeigth,
                                    color: '#1A1A1A',
                                }}
                            >
                                {colorizePercentages(item.description)}
                            </Text>
                        )}
                    </View>
                ))}
        </Card>
    )
}

const colorizePercentages = (text) => {
    // Regex que detecta números con %: +3.91%, -2%, 0%, 30.7%, etc.
    const regex = /([+-]?\d+(?:\.\d+)?)%/g

    const parts = []
    let lastIndex = 0

    text.replace(regex, (match, number, offset) => {
        // Agrega texto previo
        if (offset > lastIndex) {
            parts.push(text.slice(lastIndex, offset))
        }

        const value = parseFloat(number)
        let color = theme.colors.textPrimary
        let weight = '400'
        if (value > 0) color = 'green'
        else if (value < 0) color = 'red'
        if (value != 0) weight = '600'
        parts.push(
            <Text key={offset} style={[{ color, fontWeight: weight }]}>
                {match}
            </Text>,
        )

        lastIndex = offset + match.length
    })

    // Agrega lo que haya quedado al final
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex))
    }

    return parts
}
